import React from 'react';
import { PhotoInlineGrid } from './components/PhotoInlineGrid';
import { IPhoto } from './components/PhotoInlineGrid/interfaces';

export const PhotoGalleryPage: React.FC = (): JSX.Element => {
  const photos: IPhoto[] = [
    {
      title: 'Foto 1',
      src: '/dummy/photos/photo1.jpg',
    },
    {
      title: 'Foto 2',
      src: '/dummy/photos/photo2.jpg',
    },
    {
      title: 'Foto 3',
      src: '/dummy/photos/photo3.jpg',
    },
    {
      title: 'Foto 4',
      src: '/dummy/photos/photo4.jpg',
    },
    {
      title: 'Foto 5',
      src: '/dummy/photos/photo5.jpg',
    },
    {
      title: 'Foto 6',
      src: '/dummy/photos/photo6.jpg',
    },
  ];

  return (
    <PhotoInlineGrid
      photos={photos
        .concat(photos)
        .concat(photos)
        .concat(photos)
        .concat(photos)
        .concat(photos)}
    />
  );
};
